import * as React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import type { UiBaseProps } from "../uiProps.utils";

export enum TopBarPosition {
  // Stays at the top of the page while it scrolls.
  STICKY = "sticky",
  // Scrolls with the page, e.g. inside a sticky block of its own.
  STATIC = "static",
}

export type TopBarProps = UiBaseProps & {
  position?: TopBarPosition;
  // Lays out the bar's content row, e.g. "flex justify-between".
  contentClassName?: string;
};

// The page's app bar in the brand colour, with one row of content.
export const TopBar: React.FC<TopBarProps> = ({
  position = TopBarPosition.STICKY,
  contentClassName,
  children,
  ...rest
}) => (
  <AppBar position={position} {...rest}>
    <Toolbar className={contentClassName}>{children}</Toolbar>
  </AppBar>
);
